<template>
  <div class="mb-1 flex items-center">
    <label>
      <input
        :disabled="disabled"
        :checked="modelValue"
        type="checkbox"
        class="no-outline-on-click form-checkbox h-5 w-5 cursor-pointer rounded text-s-900 focus:ring-2 focus:ring-s-900"
        @input="$emit('update:modelValue', $event.target.checked)"
        @change="handlerInputChange($event)"
      />

      <span class="cursor-pointer pl-2 font-lato">
        {{ label }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },

    data: {
      type: Object,
      default: () => null,
    },

    modelValue: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'change'],
  methods: {
    handlerInputChange(event) {
      event.stopPropagation()
      this.$emit('change', this.data)
    },
  },
}
</script>

<style scoped>
.no-outline-on-click:focus:not(:focus-visible) {
  @apply outline-none !important;
  @apply ring-0 !important;
}
</style>
